export default "__VITE_ASSET__EFUCIyeU__"